import { action, observable } from "mobx";
import { DROPBOX_TOKEN } from "./../utils/Constants";

class Item {
  @observable id;
  @observable name;
  @observable url;
  @observable type;
  @observable size;
  @observable downloadProgress = 0;
  @observable isDownloaded = false;
  hasError = false;

  constructor(item) {
    this.name = item.name;
    this.url = item.url;
    this.type = item.type;
    this.id = item.id;
    this.size = item.size;
    this.downloadProgress = item.downloadProgress;
    this.isDownloaded = item.isDownloaded;
  }
}

const { Dropbox } = require("dropbox");
const dbx = new Dropbox({
  clientId: "o3d49yw2bgmo2yk",
  clientSecret: "eynzcgexopect75",
  refreshToken: "XKjwm04oTeEAAAAAAAAAAU0IrvM3QgjNdcjTtHTWNqKGX8LujmQZUs7-xBixpfHU",
});

/**
 * Gerencia autenticação do usuário
 */
class DropboxStore {
  @observable link = "";
  @observable items = [];
  @observable names = [];
  @observable breadcrumb = [];
  @observable isLoading = false;

  constructor() {
    if (localStorage.getItem("files-wup")) {
      this.items = JSON.parse(localStorage.getItem("files-wup"));
    }
  }

  @action
  async doSearchFolder(name) {
    this.isLoading = true;
    let _this = this;

    return await dbx
      .filesListFolder({ path: name })
      .then((response) => {
        if (response.result["entries"].length !== 0) {
          _this.items = [];
          let entries = response.result["entries"];
          entries.forEach((value) => {
            let item = new Item({
              id: value["id"],
              name: value["name"],
              type: value[".tag"],
              url: value["path_lower"],
              size: Math.round(value["size"] / 1024 / 1024) + "MB",
            });

            _this.items.push(item);
          });
        } else {
          _this.items = [];
        }
        _this.isLoading = false;
        return true;
      })
      .catch((error) => {
        console.log(error);
        _this.isLoading = false;
        return false;
      });
  }

  @action
  async doSearchTemporaryLink(url) {
    let _this = this;
    return dbx
      .filesGetTemporaryLink({ path: url })
      .then(function (response) {
        _this.link = response.result.link;
        return response.result.link;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  }
}

export default new DropboxStore();



// WEBPACK FOOTER //
// ./src/stores/DropboxStore.js